import type { IconButtonProps } from '@mui/material/IconButton';
import IconButton from '@mui/material/IconButton';
import { useTheme } from '@mui/material/styles';
import { varAlpha } from '../../theme/styles';

// ----------------------------------------------------------------------

import { Iconify } from '../../iconify';

// ----------------------------------------------------------------------

export type NavToggleButtonProps = IconButtonProps & {
  isNavMini: boolean;
};

export function NavToggleButton({ isNavMini, sx, ...other }: NavToggleButtonProps) {
  const theme = useTheme();
  
  return (
    <IconButton
      size="small"
      sx={{
        p: 0.5,
        top: 20,
        position: 'fixed',
        color: 'action.active',
        bgcolor: 'background.default',
        transform: 'translateX(-50%)',
        zIndex: 9999,
        left: isNavMini ? 'var(--layout-nav-mini-width)' : 'var(--layout-nav-vertical-width)',
        border: (theme) => `1px solid ${varAlpha(theme.vars.palette.grey['500Channel'], 0.12)}`,
        transition: (theme) =>
          theme.transitions.create(['left'], {
            easing: 'var(--layout-transition-easing)',
            duration: 'var(--layout-transition-duration)',
          }),
        '&:hover': {
          color: 'text.primary',
          bgcolor: 'background.neutral',
        },
        ...sx,
      }}
      {...other}
    >
      <Iconify
        width={16}
        icon={isNavMini ? 'solar:sidebar-minimalistic-outline' : 'solar:sidebar-minimalistic-linear'}
        sx={{
          ...(isNavMini && {
            transform: 'scaleX(-1)',
          }),
        }}
      />
    </IconButton>
  );
}
